import { captureMonitoringException } from "@/lib/monitoring";

function normalizeClientErrorMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message || error.name || "client_runtime_error";
  }

  if (typeof error === "string" && error.trim()) {
    return error.trim();
  }

  return "client_runtime_error";
}

export function createClientErrorReference(prefix = "ui") {
  const timestamp = Date.now().toString(36);
  const entropy = Math.random().toString(36).slice(2, 8);
  return `${prefix}-${timestamp}-${entropy}`;
}

export function reportClientError(
  context: string,
  error: unknown,
  details?: Record<string, unknown>,
) {
  captureMonitoringException(error, context, details);

  if (import.meta.env.DEV) {
    const message = normalizeClientErrorMessage(error);

    if (details && Object.keys(details).length > 0) {
      console.error(`[${context}] ${message}`, error, details);
      return;
    }

    console.error(`[${context}] ${message}`, error);
    return;
  }

  const payload = details && Object.keys(details).length > 0
    ? { context, error: "client_runtime_error", ...details }
    : { context, error: "client_runtime_error" };

  console.error(JSON.stringify(payload));
}
